
export enum ScriptableComponentStatus {
    Initializing = 'Initializing',
    InitializationFailed = 'InitializationFailed',
    InitializationComplete = 'InitializationComplete'
}
